import { useDispatch, useSelector, useStore } from 'react-redux';
import type { AppDispatch, RootState, RootStore } from 'store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<RootStore>();

// Made for debugging purposes - logs recomputations of all selectors
// EXAMPLE USAGE:
/*
  logSelectorRecomputations({
    totalTarget: freeToSpendSelectors.getTotalTargetValueForPlannedSpending,
    plannedOverSpentQty: freeToSpendSelectors.getPlannedOverSpentQty,
    plannedSpendingItemsForDate: freeToSpendSelectors.getPlannedSpendingItemsForDate,
    calculatedValueForPlannedSpending: freeToSpendSelectors.getCalculatedValueForPlannedSpending,
  });
*/
// @ts-expect-error FIXME TS7006
export const logSelectorRecomputations = (selectors: Record<string, any>, stopLogging) => {
//////////////////////////////////////////////
  if (stopLogging) {
    return;
  }
  const tableVal = {};
  Object.keys(selectors).forEach((selectorName: string) => {
    // @ts-expect-error FIXME TS7053
    tableVal[selectorName] = {
      recomps: selectors[selectorName].recomputations?.() ?? 'no result',
      depRecomps: selectors[selectorName].dependencyRecomputations?.() ?? 'no result',
      lastResult: selectors[selectorName].lastResult?.() ?? 'no result',
    };
  });
  // eslint-disable-next-line no-console
  console.table(tableVal);
///////////
};
